/**
 * Mock Subscriptions Data
 * Sample subscriptions for Andes tables
 * @module data/starnexus/mockSubscriptions
 */

import { Subscription } from '../../types/starnexus/andesAccess';

/**
 * Sample subscriptions with various target types and statuses
 */
export const mockSubscriptions: Subscription[] = [
  // Active DATASHARE subscriptions
  {
    subscriptionId: 'sub-001',
    datasetId: 'ds-001',
    datasetName: 'bronze_rpt_cds_retail_cga',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_retail_cga',
    tableVersion: 1,
    targetId: 'target-ds-001',
    targetName: 'delta-site-prod-datashare',
    targetType: 'DATASHARE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    description: 'Production datashare for Delta Site analytics',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-15T11:00:00Z'),
    lastSyncAt: new Date('2025-01-30T06:00:00Z')
  },
  {
    subscriptionId: 'sub-002',
    datasetId: 'ds-002',
    datasetName: 'bronze_rpt_cds_carrier_perf',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_carrier_perf',
    tableVersion: 1,
    targetId: 'target-ds-001',
    targetName: 'delta-site-prod-datashare',
    targetType: 'DATASHARE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-15T11:05:00Z'),
    lastSyncAt: new Date('2025-01-30T06:00:00Z')
  },

  // Active CRADLE subscriptions
  {
    subscriptionId: 'sub-003',
    datasetId: 'ds-001',
    datasetName: 'bronze_rpt_cds_retail_cga',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_retail_cga',
    tableVersion: 1,
    targetId: 'target-cr-001',
    targetName: 'aurora-weaver-cradle-prod',
    targetType: 'CRADLE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    description: 'Cradle pipeline for AuroraWeaver production',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-16T09:00:00Z'),
    lastSyncAt: new Date('2025-01-30T05:30:00Z')
  },
  {
    subscriptionId: 'sub-004',
    datasetId: 'ds-003',
    datasetName: 'bronze_rpt_cds_lsp_perf',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_lsp_perf',
    tableVersion: 1,
    targetId: 'target-cr-001',
    targetName: 'aurora-weaver-cradle-prod',
    targetType: 'CRADLE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-16T09:10:00Z'),
    lastSyncAt: new Date('2025-01-30T05:30:00Z')
  },

  // Active GLUE subscriptions
  {
    subscriptionId: 'sub-005',
    datasetId: 'ds-002',
    datasetName: 'bronze_rpt_cds_carrier_perf',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_carrier_perf',
    tableVersion: 1,
    targetId: 'target-gl-001',
    targetName: 'agl-analytics-glue-catalog',
    targetType: 'GLUE',
    region: 'us-west-2',
    versionMigrationStrategy: 'MANUAL',
    status: 'active',
    description: 'Glue catalog for cross-region analytics',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-18T14:00:00Z'),
    lastSyncAt: new Date('2025-01-29T18:00:00Z')
  },

  // Pending subscriptions
  {
    subscriptionId: 'sub-006',
    datasetId: 'ds-004',
    datasetName: 'gold_logistics_metrics',
    providerId: '8a2b3c4d-5e6f-7890-abcd-ef1234567890',
    providerName: 'agl_analytics_prod',
    tableName: 'gold_logistics_metrics',
    tableVersion: 2,
    targetId: 'target-ds-002',
    targetName: 'quicksight-prod-datashare',
    targetType: 'DATASHARE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'pending',
    description: 'QuickSight datashare for logistics dashboards',
    createdBy: 'analyst1',
    createdAt: new Date('2025-01-29T10:00:00Z')
  },
  {
    subscriptionId: 'sub-007',
    datasetId: 'ds-005',
    datasetName: 'bronze_raw_events',
    providerId: '9b3c4d5e-6f78-90ab-cdef-123456789012',
    providerName: 'agl_events_prod',
    tableName: 'bronze_raw_events',
    tableVersion: 1,
    targetId: 'target-cr-002',
    targetName: 'aurora-weaver-cradle-dev',
    targetType: 'CRADLE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'pending',
    description: 'Dev Cradle for testing event processing',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-30T08:00:00Z')
  },

  // Failed subscriptions
  {
    subscriptionId: 'sub-008',
    datasetId: 'ds-006',
    datasetName: 'silver_inventory_snapshot',
    providerId: 'ab4c5d6e-7f89-0abc-def1-234567890123',
    providerName: 'agl_inventory_prod',
    tableName: 'silver_inventory_snapshot',
    tableVersion: 3,
    targetId: 'target-gl-002',
    targetName: 'inventory-glue-catalog',
    targetType: 'GLUE',
    region: 'eu-west-1',
    versionMigrationStrategy: 'AUTO',
    status: 'failed',
    description: 'EU region Glue catalog',
    createdBy: 'pipeline-svc',
    createdAt: new Date('2025-01-25T12:00:00Z'),
    errorMessage: 'Failed to create Glue table: Access denied. Verify IAM permissions for cross-region access.'
  },
  {
    subscriptionId: 'sub-009',
    datasetId: 'ds-007',
    datasetName: 'gold_financial_summary',
    providerId: 'bc5d6e7f-8901-abcd-ef23-456789012345',
    providerName: 'agl_finance_prod',
    tableName: 'gold_financial_summary',
    tableVersion: 1,
    targetId: 'target-ds-003',
    targetName: 'finance-reporting-datashare',
    targetType: 'DATASHARE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'failed',
    createdBy: 'financeadmin',
    createdAt: new Date('2025-01-26T09:00:00Z'),
    errorMessage: 'Subscription creation failed: Table version mismatch. Expected version 2, got version 1.'
  },

  // More active subscriptions for variety
  {
    subscriptionId: 'sub-010',
    datasetId: 'ds-003',
    datasetName: 'bronze_rpt_cds_lsp_perf',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_lsp_perf',
    tableVersion: 1,
    targetId: 'target-ds-001',
    targetName: 'delta-site-prod-datashare',
    targetType: 'DATASHARE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-17T10:00:00Z'),
    lastSyncAt: new Date('2025-01-30T06:00:00Z')
  },
  {
    subscriptionId: 'sub-011',
    datasetId: 'ds-001',
    datasetName: 'bronze_rpt_cds_retail_cga',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_retail_cga',
    tableVersion: 1,
    targetId: 'target-gl-001',
    targetName: 'agl-analytics-glue-catalog',
    targetType: 'GLUE',
    region: 'us-west-2',
    versionMigrationStrategy: 'MANUAL',
    status: 'active',
    description: 'Glue catalog for ML training pipelines',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-20T15:00:00Z'),
    lastSyncAt: new Date('2025-01-29T18:00:00Z')
  },
  {
    subscriptionId: 'sub-012',
    datasetId: 'ds-002',
    datasetName: 'bronze_rpt_cds_carrier_perf',
    providerId: '75d99108-5fc6-449b-a9f9-d0716f2bbc29',
    providerName: 'starcatcher_origin_prod',
    tableName: 'bronze_rpt_cds_carrier_perf',
    tableVersion: 1,
    targetId: 'target-cr-001',
    targetName: 'aurora-weaver-cradle-prod',
    targetType: 'CRADLE',
    region: 'us-east-1',
    versionMigrationStrategy: 'AUTO',
    status: 'active',
    createdBy: 'yyangzam',
    createdAt: new Date('2025-01-16T09:15:00Z'),
    lastSyncAt: new Date('2025-01-30T05:30:00Z')
  }
];

export default mockSubscriptions;
